(function () {
  'use strict';
  if (window.ERSRegularProductPdp) { window.ERSRegularProductPdp.initialize(document); return; }
  function initialize(root) {
    if (!root || root._ersRegularPdp) return;
    var bar = root.querySelector('[data-regular-sticky]');
    var purchase = root.querySelector('.product-order-card');
    if (!bar || !purchase) return;
    var controller = new AbortController();
    var frame = 0;
    var activeId = "";
    var syncing = false;
    var dismissed = false;
    var gallery = root.querySelector('.product-gallery-layout');
    var stage = root.querySelector('.product-gallery-stage');
    var thumbList = root.querySelector('.product-photo-thumbs');
    var thumbLayoutKey = '';
    var share = root.querySelector('[data-product-share]');
    var shareToggle = share && share.querySelector('[data-share-toggle]');
    var shareMenu = share && share.querySelector('[data-share-menu]');
    var shareTimer = 0;
    var mainForm = purchase.querySelector('form[action*="/cart/add"]');
    var mainQuantity = purchase.querySelector('[data-product-quantity-input]');
    var mainButton = purchase.querySelector('.btn--add-to-cart');
    var stickyForm = bar.querySelector('[data-sticky-form]');
    var stickyQuantity = bar.querySelector('[data-sticky-quantity]');
    var stickyButton = bar.querySelector('[data-sticky-add]');
    var data = {};
    try { data = JSON.parse(root.querySelector('[id^="ProductJson-"]').textContent); } catch (error) {}
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-regular-section][id]'));
    // The sidebar specifications precede the matching collection in navigation.
    var specificationsIndex = sections.findIndex(function (section) { return section.id.indexOf('RegularSpecs-') === 0; });
    var collectionIndex = sections.findIndex(function (section) { return section.getAttribute('data-regular-role') === 'line'; });
    if (collectionIndex !== -1 && specificationsIndex > collectionIndex) {
      sections.splice(collectionIndex, 0, sections.splice(specificationsIndex, 1)[0]);
    }
    var tabs = bar.querySelector('[data-sticky-tabs]');
    sections.forEach(function (section) {
      var link = document.createElement('a');
      link.href = '#' + section.id;
      link.textContent = section.getAttribute('data-regular-section-label');
      link._section = section;
      tabs.appendChild(link);
    });
    function listen(target, name, fn, options) {
      if (target) target.addEventListener(name, fn, Object.assign({}, options, { signal: controller.signal }));
    }
    var mobileGrids = [];
    root.querySelectorAll('[data-regular-role="line"], [data-regular-role="related"], [data-regular-role="items"]').forEach(function (section) {
      var viewport = section.querySelector('[data-product-related-viewport]');
      var track = section.querySelector('[data-product-related-track]');
      if (!viewport || !track) return;
      var grid = { section: section, viewport: viewport, track: track, tabIndex: viewport.getAttribute('tabindex'), trackId: track.id, mobile: null };
      if (track.children.length > 4) {
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'regular-grid-toggle';
        toggle.textContent = root.getAttribute('data-regular-grid-more');
        toggle.setAttribute('aria-expanded', 'false');
        track.id = track.id || section.id + '-grid';
        toggle.setAttribute('aria-controls', track.id);
        if (section.getAttribute('aria-labelledby')) toggle.setAttribute('aria-describedby', section.getAttribute('aria-labelledby'));
        section.setAttribute('data-regular-mobile-grid', '');
        section.appendChild(toggle);
        grid.toggle = toggle;
        listen(toggle, 'click', function () {
          var expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = root.getAttribute(expanded ? 'data-regular-grid-less' : 'data-regular-grid-more');
          section.toggleAttribute('data-regular-grid-expanded', expanded);
          // Continue keyboard navigation into newly revealed items.
          var firstNewItem = track.children[4];
          var focusTarget = expanded && firstNewItem && (firstNewItem.matches('a') ? firstNewItem : firstNewItem.querySelector('a'));
          if (focusTarget) focusTarget.focus({ preventScroll: true });
          schedule();
        });
      }
      mobileGrids.push(grid);
    });
    function layoutMobileGrids() {
      var mobile = window.innerWidth <= 639;
      mobileGrids.forEach(function (grid) {
        if (grid.mobile === mobile) return;
        grid.mobile = mobile;
        // A static grid uses its individual links, rather than an extra carousel tab stop.
        if (mobile) {
          var viewportFocused = document.activeElement === grid.viewport;
          grid.viewport.removeAttribute('tabindex');
          if (viewportFocused) {
            var firstLink = grid.track.querySelector('a');
            if (firstLink) firstLink.focus({ preventScroll: true });
          }
        }
        else if (grid.tabIndex !== null) grid.viewport.setAttribute('tabindex', grid.tabIndex);
        if (!mobile && grid.toggle && document.activeElement === grid.toggle) grid.viewport.focus({ preventScroll: true });
      });
    }
    function layoutThumbnails() {
      if (!gallery || !stage || !thumbList) return;
      var count = thumbList.children.length;
      var size = parseFloat(getComputedStyle(root).getPropertyValue('--regular-thumb-size'));
      var height = stage.getBoundingClientRect().height;
      var mobile = window.innerWidth <= 639;
      var tablet = window.innerWidth >= 640 && window.innerWidth <= 900;
      var key = [count, size, height, mobile, tablet].join(':');
      if (!count || !size || key === thumbLayoutKey) return;
      thumbLayoutKey = key;
      var rows = mobile ? 1 : tablet ? count : Math.max(1, Math.floor((height + 12) / (size + 12)), Math.ceil(count / 2));
      gallery.style.setProperty('--regular-thumb-rows', rows);
      gallery.style.setProperty('--regular-thumb-columns', Math.ceil(count / rows));
    }
    function layoutProductRows() {
      root.querySelectorAll('.regular-original-products[data-regular-role="related"]').forEach(function (section) {
        var viewport = section.querySelector('[data-product-related-viewport]');
        var track = section.querySelector('[data-product-related-track]');
        var total = track.children.length;
        var width = viewport.clientWidth;
        if (!width || !total) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
        var minimum = width < 420 ? 168 : width < 700 ? 180 : 200;
        var capacity = Math.max(1, Math.floor((width + gap) / (minimum + gap)));
        // Extra desktop width exposes more cards without enlarging a short row.
        var visible = window.innerWidth > 900 ? capacity : Math.min(total, capacity);
        if ((width - gap * (visible - 1)) / visible > 280 && visible < capacity) visible = Math.min(capacity, Math.ceil((width + gap) / (280 + gap)));
        section.style.setProperty('--regular-visible-cards', visible);
      });
    }
    function setShareOpen(open, restoreFocus) {
      if (!shareMenu) return;
      shareMenu.hidden = !open;
      shareToggle.setAttribute('aria-expanded', String(open));
      var items = shareMenu.querySelectorAll('[role="menuitem"]');
      items.forEach(function (item, index) { item.tabIndex = open && index === 0 ? 0 : -1; });
      if (open && items.length) items[0].focus({ preventScroll: true });
      else if (restoreFocus) shareToggle.focus({ preventScroll: true });
    }
    function syncShareImage(imageId) {
      if (!share || /^(external-|video-)/.test(String(imageId))) return;
      var thumb = Array.prototype.find.call(root.querySelectorAll('.product-photo-thumb'), function (item) { return item.getAttribute('data-image-id') === String(imageId); });
      var pinterest = share.querySelector('[data-share-pinterest]');
      if (!thumb || !pinterest) return;
      try {
        var image = new URL(thumb.getAttribute('href'), share.getAttribute('data-share-url'));
        if (image.origin === window.location.origin) image = new URL(image.pathname + image.search, new URL(share.getAttribute('data-share-url')).origin);
        if (image.protocol === 'http:') image.protocol = 'https:';
        var url = new URL(pinterest.href);
        url.searchParams.set('media', image.href);
        pinterest.href = url.href;
      } catch (error) {}
    }
    function headerOffset() {
      var bottom = 0;
      document.querySelectorAll('.site-header, .nav-bar, .header-bar, #mobileNavBar').forEach(function (header) {
        var style = getComputedStyle(header);
        var rect = header.getBoundingClientRect();
        if (style.display !== 'none' && style.visibility === 'visible' && rect.height > 0 && (style.position === 'fixed' || style.position === 'sticky') && rect.top <= 1 && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
      });
      return bottom;
    }
    function syncPurchase() {
      if (!mainForm) return;
      var selector = mainForm.querySelector('select[name="id"], input[name="id"]');
      var id = selector && selector.value;
      var variant = (data.variants || []).find(function (item) { return String(item.id) === String(id); });
      if (stickyForm) { stickyForm.querySelector('[name="id"]').value = id || ''; stickyForm.setAttribute('data-variant-id', id || ''); }
      var price = purchase.querySelector('[id^="productPrice-"]');
      if (price && bar.querySelector('[data-sticky-price]')) {
        var readablePrice = price.querySelector('.visually-hidden');
        var priceText = (readablePrice || price).textContent.trim();
        bar.querySelector('[data-sticky-price]').textContent = priceText;
        root.querySelectorAll('[data-current-comparison-price]').forEach(function (cell) { cell.textContent = priceText; });
      }
      bar.querySelector('[data-sticky-sku]').textContent = variant ? variant.sku || '' : '';
      root.querySelectorAll('[data-current-comparison-sku]').forEach(function (cell) { cell.textContent = variant ? variant.sku || '' : ''; });
      bar.querySelector('[data-sticky-variant]').textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
      if (variant) {
        var image = bar.querySelector('[data-sticky-image]');
        if (image && variant.featured_image && variant.featured_image.src) image.src = variant.featured_image.src;
      }
      if (mainQuantity && stickyQuantity) {
        ['min', 'max', 'step'].forEach(function (name) {
          if (mainQuantity.hasAttribute(name)) stickyQuantity.setAttribute(name, mainQuantity.getAttribute(name));
          else stickyQuantity.removeAttribute(name);
        });
        if (document.activeElement !== stickyQuantity) stickyQuantity.value = mainQuantity.value;
        stickyQuantity.disabled = mainQuantity.disabled;
      }
      if (mainButton && stickyButton && stickyForm.getAttribute('aria-busy') !== 'true') {
        stickyButton.disabled = mainButton.disabled || !id;
        stickyButton.textContent = mainButton.textContent.trim();
        stickyButton.setAttribute('data-idle-label', mainButton.textContent.trim());
      }
    }
    function update() {
      frame = 0;
      layoutThumbnails();
      layoutProductRows();
      layoutMobileGrids();
      var top = headerOffset();
      bar.style.top = top + 'px';
      // Keep an already-visible bar until the main purchase card is actually
      // visible below it. This prevents an About-tab jump from hiding the bar
      // while the purchase controls are still covered by that same bar.
      var coveredHeight = bar.hidden ? 0 : bar.getBoundingClientRect().height;
      var pastPurchase = purchase.getBoundingClientRect().bottom <= top + coveredHeight;
      if (!pastPurchase) dismissed = false;
      var visible = pastPurchase && !dismissed;
      bar.hidden = !visible;
      var offset = top + (visible ? bar.getBoundingClientRect().height : 0) + 12;
      root.style.setProperty('--regular-anchor-offset', offset + 'px');
      var active = null;
      var nearest = -Infinity;
      sections.forEach(function (section) {
        var y = section.getBoundingClientRect().top;
        if (y <= offset + 20 && y > nearest) { active = section; nearest = y; }
      });
      if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) {
        var latest = -Infinity;
        sections.forEach(function (section) { var y = section.getBoundingClientRect().top; if (y < window.innerHeight && y > latest) { active = section; latest = y; } });
      }
      var activeLink = null;
      Array.prototype.forEach.call(tabs.children, function (link) {
        if (link._section === active) { link.setAttribute('aria-current', 'location'); activeLink = link; }
        else link.removeAttribute('aria-current');
      });
      if (visible && activeLink && activeId !== activeLink.hash) {
        activeId = activeLink.hash;
        var linkBox = activeLink.getBoundingClientRect();
        var tabsBox = tabs.getBoundingClientRect();
        if (linkBox.left < tabsBox.left) tabs.scrollLeft -= tabsBox.left - linkBox.left;
        else if (linkBox.right > tabsBox.right) tabs.scrollLeft += linkBox.right - tabsBox.right;
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    function moveQuantity(from, to) {
      if (syncing || !from || !to) return;
      syncing = true;
      to.value = from.value;
      to.dispatchEvent(new Event('change', { bubbles: true }));
      from.value = to.value;
      syncing = false;
    }
    listen(shareToggle, 'click', function () { setShareOpen(shareMenu.hidden, false); });
    listen(shareToggle, 'keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      setShareOpen(true, false);
      if (event.key === 'ArrowUp') {
        var items = shareMenu.querySelectorAll('[role="menuitem"]');
        items.forEach(function (item, index) { item.tabIndex = index === items.length - 1 ? 0 : -1; });
        items[items.length - 1].focus();
      }
    });
    listen(shareMenu, 'keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); setShareOpen(false, true); return; }
      if (event.key === 'Tab') { clearTimeout(shareTimer); shareTimer = setTimeout(function () { setShareOpen(false, false); }, 0); return; }
      var items = Array.prototype.slice.call(shareMenu.querySelectorAll('[role="menuitem"]'));
      var index = items.indexOf(document.activeElement);
      if (['ArrowDown','ArrowUp','Home','End'].indexOf(event.key) < 0) return;
      event.preventDefault();
      var next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
      items.forEach(function (item, index) { item.tabIndex = index === next ? 0 : -1; });
      items[next].focus();
    });
    listen(shareMenu, 'click', function (event) {
      if (event.target.closest('[data-share-print]')) { setShareOpen(false, true); window.print(); }
      else if (event.target.closest('a')) setShareOpen(false, false);
    });
    listen(document, 'pointerdown', function (event) { if (share && !share.contains(event.target)) setShareOpen(false, false); });
    listen(document, 'focusin', function (event) { if (share && !share.contains(event.target)) setShareOpen(false, false); });
    listen(root, 'product:image:change', function (event) { syncShareImage(event.detail.imageId); });
    listen(stickyQuantity, 'change', function () { moveQuantity(stickyQuantity, mainQuantity); });
    listen(mainQuantity, 'change', function () { if (!syncing && stickyQuantity) stickyQuantity.value = mainQuantity.value; });
    listen(root, 'product:variant:change', function () { requestAnimationFrame(syncPurchase); });
    listen(mainForm, 'change', function () { requestAnimationFrame(syncPurchase); });
    listen(stickyForm, 'submit', function () { moveQuantity(stickyQuantity, mainQuantity); });
    listen(window, 'scroll', schedule, { passive: true });
    listen(window, 'resize', function () { activeId = ''; schedule(); }, { passive: true });
    listen(tabs, 'click', function (event) {
      var link = event.target.closest('a');
      if (!link || !link._section) return;
      event.preventDefault();
      var target = link._section;
      var offset = headerOffset() + bar.getBoundingClientRect().height + 12;
      window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior: 'instant' });
      var heading = target.querySelector('h2,h3') || target;
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
      schedule();
    });
    listen(bar.querySelector('[data-sticky-dismiss]'), 'click', function () {
      var active = tabs.querySelector('[aria-current]');
      var target = active && active._section;
      if (!target) target = sections.find(function (section) { return section.getBoundingClientRect().bottom > headerOffset(); });
      dismissed = true;
      update();
      var heading = target && (target.querySelector('h2,h3') || target);
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
    });
    listen(bar.querySelector('[data-sticky-top]'), 'click', function () {
      window.scrollTo({ top: 0, behavior: 'instant' });
      var title = root.querySelector('h1');
      title.setAttribute('tabindex', '-1');
      title.focus({ preventScroll: true });
      update();
    });
    var resize = new ResizeObserver(schedule);
    resize.observe(purchase);
    resize.observe(bar);
    if (stage) resize.observe(stage);
    root.querySelectorAll('.regular-original-products[data-regular-role="related"] [data-product-related-viewport]').forEach(function (viewport) { resize.observe(viewport); });
    var priceObserver = new MutationObserver(function () { requestAnimationFrame(syncPurchase); });
    if (mainButton) priceObserver.observe(mainButton, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    var priceNode = purchase.querySelector('[id^="productPrice-"]');
    if (priceNode) priceObserver.observe(priceNode, { childList: true, subtree: true });
    if (stickyForm) priceObserver.observe(stickyForm, { attributes: true, attributeFilter: ['aria-busy'] });
    root._ersRegularPdp = { destroy: function () {
      clearTimeout(shareTimer); setShareOpen(false, false); controller.abort(); resize.disconnect(); priceObserver.disconnect();
      mobileGrids.forEach(function (grid) {
        if (grid.toggle) grid.toggle.remove();
        grid.section.removeAttribute('data-regular-mobile-grid');
        grid.section.removeAttribute('data-regular-grid-expanded');
        if (grid.tabIndex === null) grid.viewport.removeAttribute('tabindex');
        else grid.viewport.setAttribute('tabindex', grid.tabIndex);
        if (grid.trackId) grid.track.id = grid.trackId;
        else grid.track.removeAttribute('id');
      });
      if (frame) cancelAnimationFrame(frame); tabs.replaceChildren(); root._ersRegularPdp = null;
    } };
    syncPurchase();
    update();
    requestAnimationFrame(syncPurchase);
  }
  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-regular-pdp]')) initialize(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-regular-pdp]').forEach(initialize);
  }
  window.ERSRegularProductPdp = { initialize: initializeAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { var root = event.target.matches('[data-regular-pdp]') ? event.target : event.target.querySelector('[data-regular-pdp]'); if (root && root._ersRegularPdp) root._ersRegularPdp.destroy(); });
}());
